

const generationTime = (dt) => {
    return dt.substr(11)
}

export default generationTime;